<template>
    <div class="col-md-4">
        <div class="card">
            <div class="card-body">
                <h4 class="card-title">
                    {{show.title}} <br><div class="btn">
                      Рейтинг <span class="badge badge-secondary">
                          {{show.rating*2}} из 10
                      </span>
                    </div>
                </h4>
                <p class="card-text">
                   <img
                        class="rounded"
                        :src="getImg"
                        >
                </p>
                <a is="router-link" :to="'/detail/'+show.id" class="btn btn-primary">Подробнее</a>
            </div>
        </div>
        <br>
    </div>
</template>

<script>

    export default {
        data() {
            return {
                noPhoto: require('./../img/no_photo.jpg') 
            }
        },
        computed: {
            getImg: function(){
                if (!!this.show.image){
                    return this.show.image
                } else{
                    return this.noPhoto
                }
            }
        },
        props: ['show']
    }

</script>
<style scoped>
    .btn-primary{
        width: 100%;
    }
    img{
        width: 100%;
    }
    
</style>



// WEBPACK FOOTER //
// src/comp/ShowListItem.vue?76416853